<template>
  <div class="navWrap">
    <div class="navLeft">
      <!-- <img class="logo" src="../assets/images/logo.png" /> -->
      <span style="font-size: 25px">涿溪防窜货</span>
      <div class="navBlockWrap">
        <div class="navBlock" v-for="item in list" :key="item.name">
          <router-link :to="item.url">{{item.name}}</router-link>
        </div>
      </div>
    </div>

    <MyButton class="navBtn" @clickFn="showForm">联系销售部</MyButton>
  </div>
</template>
<script>
import MyButton from '@/components/Mybutton.vue'
export default {
  name: 'navigation',
  data () {
    return {
      list: [
        // {
        //   name: '产品',
        //   url: ''
        // },
        // {
        //   name: '解决方案',
        //   url: ''
        // },
        // {
        //   name: '行业趋势',
        //   url: ''
        // },
        // {
        //   name: '客户案例',
        //   url: ''
        // },
        // {
        //   name: '认识我们',
        //   url: ''
        // }
      ]
    }
  },
  components:{
    MyButton
  },
  methods:{
    showForm() {
      this.$emit('changeVisible', true)
    }
  }

}
</script>
<style scoped lang="scss">
.navWrap{
  height: 70px;
  background: #FFFFFF;
  box-shadow: -6px 2px 17px 0px rgba(232, 234, 240, 0.5);
  position: fixed;
  top: 0;
  left:0;
  right: 0;
  z-index: 99;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
  .navLeft{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    .logo{
    width: 125px;
    height: 40px;
  }
  .navBlockWrap{
    padding-left: 50px;
    .navBlock {
      display: inline-block;
      font-size: 16px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #36444D;
      line-height: 22px;
      padding: 24px 20px;
      > a {
        text-decoration: none;
        color: #36444D;
      }
      > a:hover{
        color: #8252D7;
      }
    }
  }
  }
  .navBtn{
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue